var _a, _b;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import { fetchAvailableBadges, fetchAvailableBadgesSuccess, awardingBadge, awardBadgeSuccess, awardBadgeFail, } from './actionCreators';
import { reduxKey } from './constants';
var handler = handleActions((_a = {},
    _a[awardingBadge.toString()] = function (state, action) {
        return __assign(__assign({}, state), { isAwarding: true, errorMsg: undefined });
    },
    _a[awardBadgeSuccess.toString()] = function (state, action) {
        return __assign(__assign({}, state), { isAwarding: false, errorMsg: undefined });
    },
    _a[awardBadgeFail.toString()] = function (state, action) {
        return __assign(__assign({}, state), { isAwarding: false, errorMsg: action.payload.errorMsg });
    },
    _a[fetchAvailableBadges.toString()] = function (state, action) {
        var _a;
        return __assign(__assign({}, state), { awardableBadges: __assign(__assign({}, state.awardableBadges), (_a = {}, _a[action.payload.userId] = {
                isLoading: true,
                results: [],
            }, _a)), errorMsg: undefined });
    },
    _a[fetchAvailableBadgesSuccess.toString()] = function (state, action) {
        var _a;
        return __assign(__assign({}, state), { awardableBadges: __assign(__assign({}, state.awardableBadges), (_a = {}, _a[action.payload.userId] = {
                isLoading: false,
                results: action.payload.results,
            }, _a)) });
    },
    _a), {});
export default (_b = {},
    _b[reduxKey] = handler,
    _b);
//# sourceMappingURL=reducer.js.map